import { Icons } from 'assets/icons/icons.index';
import { Button, CardBody, Input, TagLabel } from 'components';
import { Coupon } from 'pages/Settings/pages/Add-subscription/types/Add-subscription.types';
import { formatPrice } from 'utils/payments.utils';
import './Form-cupon-price.css';

interface FormCouponPriceProps {
  couponCode: string;
  couponError: string | null;
  appliedCoupon: Coupon | null;
  handleCouponCode: (coupon: string) => void;
  isAnyProductSelected: boolean;
  resetCoupon: () => void;
  handleApplyCoupon: () => void;
  loadingCoupon: boolean;
}

const FormCouponPrice = ({
  couponCode,
  couponError,
  appliedCoupon,
  handleCouponCode,
  isAnyProductSelected,
  resetCoupon,
  handleApplyCoupon,
  loadingCoupon,
}: FormCouponPriceProps) => {
  return (
    <CardBody>
      <div className="form__coupon__container">
        <div className="form__coupon__title">
          <h5>¿Tienes un cupón?</h5>
        </div>
        <div className="form__coupon__content">
          <Input
            label="Agregar Cupón"
            id="form__coupon__prices__buy__plan"
            type="alphanumeric"
            name="coupon"
            onChange={(e) => handleCouponCode(e.target.value)}
            value={couponCode}
            isTouched={false}
            errorInput={''}
            isRequired={false}
          />
          <Button
            className="button__coupon"
            size="medium"
            template="primary"
            color="secondary"
            typeStyle="square"
            type="button"
            isDisabled={
              !couponCode.trim() || !isAnyProductSelected || loadingCoupon
            }
            onClick={handleApplyCoupon}
            isLoading={false}
          >
            Aplicar
          </Button>
        </div>
        {!isAnyProductSelected && (
          <p className="text-yellow-500 mt-2">
            Selecciona al menos un producto para aplicar el cupón.
          </p>
        )}
        {couponError && (
          <p className="coupon-error">{`${couponCode} ${couponError}`}</p>
        )}
        {appliedCoupon && (
          <p className="coupon-success">
            Cupón aplicado para: {appliedCoupon.price.alias_title}{' '}
            {appliedCoupon.name} (
            {appliedCoupon.is_percent
              ? `${appliedCoupon.amount}%`
              : `$${appliedCoupon.amount}`}{' '}
            de descuento)
          </p>
        )}

        {appliedCoupon && (
          <div className="form__coupon__info__container">
            <TagLabel type="secondary" typeStyle="square" onClick={resetCoupon}>
              <img src={Icons.iconTag} alt="icono tag" />
              <div className="tag__label__info__coupon">
                <span className="tag__label__info__coupon--bold">
                  {appliedCoupon.name.toLocaleUpperCase()}
                </span>
                <span>
                  {appliedCoupon.is_percent
                    ? `${appliedCoupon.amount}% dcto.`
                    : `-$${formatPrice(appliedCoupon.amount, 'pr')}`}
                </span>
              </div>
            </TagLabel>
          </div>
        )}
      </div>
    </CardBody>
  );
};

export default FormCouponPrice;
